<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <div v-if="!job_status">
                <div
                    v-for="(group, g_index) in filtered_job_groups"
                    :key="'jg-' + g_index"
                    class="card mb-3"
                >
                    <div class="card-header bg-white">
                        <h6 class="card-title">{{ group.label }}</h6>
                    </div>
                    <div class="card-body pb-0">
                        <div class="row">
                            <div class="col-12">
                                <limitless-button
                                    v-for="job in group.jobs" :key="'j-' + job.job"
                                    @click="dispatch(job.job)"
                                    class="mr-3 mb-3"
                                    :icon="job.icon"
                                    :busy="busy_working && job_type === job.job"
                                    :disabled="busy_working"
                                >
                                    {{ job.name }}
                                </limitless-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="mt-3">
                <h5 class="mb-3">Status: {{ job_status_message }}</h5>

                <b-progress
                    :value="this.job_status.progress_now"
                    :max="this.job_status.progress_max"
                    :variant="(this.job_status.progress_now === this.job_status.progress_max ? 'success' : (this.job_status.status === 'failed' ? 'error' : 'primary'))"
                    :animated="busy_working"
                    show-progress>
                </b-progress>

                <div class="mt-3 card-group-control card-group-control-right">
                    <div v-for="(message, m_idx) in status_log_errors" :key="'error-' + m_idx">
                        <div v-if="message.data" class="card">
                            <div class="card-header alert alert-danger bg-nobg mb-0">
                                <h6 class="card-title mb-0">
                                    <a data-toggle="collapse" class="text-body collapsed" :href="'#accordion-control-error-' + m_idx">{{ message.message }}</a>
                                </h6>
                                <a v-if="message.data && message.data.link" :href="message.data.link" target="_blank">{{ message.data.link }}</a>
                            </div>
                            <div :id="'accordion-control-error-' + m_idx" class="collapse">
                                <div class="card-body">
                                    <pre v-html="message.data"></pre>
                                </div>
                            </div>
                        </div>
                        <div v-else class="alert alert-danger">
                            <h6>{{ message.message }}</h6>
                            <a v-if="message.data && message.data.link" :href="message.data.link" target="_blank">{{ message.data.link }}</a>
                        </div>
                    </div>
                    <div v-for="(message, m_idx) in status_log_warnings" :key="'warning-' + m_idx">
                        <div v-if="message.data" class="card">
                            <div class="card-header alert alert-warning bg-nobg mb-0">
                                <h6 class="card-title mb-0">
                                    <a data-toggle="collapse" class="text-body collapsed" :href="'#accordion-control-warning-' + m_idx">{{ message.message }}</a>
                                </h6>
                                <a v-if="message.data && message.data.link" :href="message.data.link" target="_blank">{{ message.data.link }}</a>
                            </div>
                            <div :id="'accordion-control-warning-' + m_idx" class="collapse">
                                <div class="card-body">
                                    <pre v-html="message.data"></pre>
                                </div>
                            </div>
                        </div>
                        <div v-else class="alert alert-warning">
                            <h6>{{ message.message }}</h6>
                            <a v-if="message.data && message.data.link" :href="message.data.link" target="_blank">{{ message.data.link }}</a>
                        </div>
                    </div>
                    <div v-for="(message, m_idx) in status_log_infos" :key="'info-' + m_idx">
                        <div v-if="message.data" class="card">
                            <div class="card-header alert alert-info bg-nobg mb-0">
                                <h6 class="card-title mb-0">
                                    <a data-toggle="collapse" class="text-body collapsed" :href="'#accordion-control-info-' + m_idx">{{ message.message }}</a>
                                </h6>
                                <a v-if="message.data && message.data.link" :href="message.data.link" target="_blank">{{ message.data.link }}</a>
                            </div>
                            <div :id="'accordion-control-info-' + m_idx" class="collapse">
                                <div class="card-body">
                                    <pre v-html="message.data"></pre>
                                </div>
                            </div>
                        </div>
                        <div v-else class="alert alert-info">
                            <h6>{{ message.message }}</h6>
                            <a v-if="message.data && message.data.link" :href="message.data.link" target="_blank">{{ message.data.link }}</a>
                        </div>
                    </div>
                </div>

                <div v-if="job_status.status === 'finished'" class="alert alert-success">
                    Jobbet har körs klart!
                    <span v-if="job_status.output && job_status.output.total_api_requests"> {{ job_status.output.total_api_requests }} st anrop har gjorts mot externt API.</span>
                </div>
                <div v-if="job_status.status === 'failed'" class="alert alert-danger">Jobbet kördes ej klart p.g.a. ett oväntat fel.</div>

                <div v-if="job_status.output && job_status.output.log" id="fortnox-log" class="card">
                    <div class="card-body">
                        <div v-for="(message, m_idx) in job_status.output.log" :key="'log-' + m_idx">
                            <div v-if="message.type === 'error'" class="text-danger">{{ message.date }}: {{ message.message }}</div>
                            <div v-else-if="message.type === 'warning'" class="text-warning">{{ message.date }}: {{ message.message }}</div>
                            <div v-else-if="message.type === 'info'"  class="text-info">{{ message.date }}: {{ message.message }}</div>
                            <div v-else class="">{{ message.date }}: {{ message.message }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div> <!-- /content -->

        <b-modal id="modal-register-worktime" title="Registrera tider" @ok="dispatch('fortnox_register_worktime')">
            <div class="form-group">
                <user-filter
                    v-model="dispatch_data.user_ids"
                    :reduce="item => item.id"
                    placeholder="-- Alla med Fortnox lön --"
                    multiple
                ></user-filter>
            </div>
            <div class="form-group">
                <vue-select
                    v-model="timecare_period"
                    :options="select_timecard_periods"
                    label="text"
                    :reduce="item => item.id"
                    placeholder="Välj..."
                />
            </div>

            <template #modal-footer="{ ok, cancel }">
                <button type="button" class="btn btn-light" @click="cancel()">Avbryt</button>
                <limitless-button type="button" @click="ok()" icon="icon-file-upload">Registrera arbetade tider</limitless-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import { BProgress } from 'bootstrap-vue';
import { hasPermission } from '@services/Helpers';
import UserFilter from '@components/Filters/UserFilter.vue';
import VueSelect from '@components/Wrappers/VueSelect.vue';

export default {
    name: 'DispatchJobs',
    components: {
        VueSelect,
        UserFilter,
        LimitlessButton,
        LimitlessPageHeader,
        BProgress,
    },
    data: () => ({
        busy_working: false,
        job_status_id: null,
        job_status: null,
        job_type: '',
        interval: null,
        timecare_period: null,
        users: [],
        dispatch_data: {
            job: '',
        },
        jobs_groups: [
            {
                label: 'Postnummer',
                jobs: [
                    {
                        name: 'Hämta okända postnummer',
                        icon: 'icon-database-insert',
                        job: 'find_postalcodes',
                        permisson: ['red_fortnox_integration'],
                    },
                    {
                        name: 'Automaträtta postnummer',
                        icon: 'icon-database-edit2',
                        job: 'autofix_postalcodes',
                        permisson: ['red_fortnox_integration'],
                    },
                    {
                        name: 'Uppdatera postnummer',
                        icon: 'icon-database-edit2',
                        job: 'update_postalcodes_todo',
                        permisson: ['red_fortnox_integration'],
                    },
                    {
                        name: 'Uppdatera postnummer (Nattlig)',
                        icon: 'icon-database-refresh',
                        job: 'update_postalcodes',
                        permisson: ['red_fortnox_integration'],
                    },
                ],
            },
            {
                label: 'Fakturering',
                jobs: [
                    {
                        name: 'Registrera fakturor (Fortnox)',
                        icon: 'icon-file-upload',
                        job: 'fortnox_register_invoices',
                        permisson: ['red_fortnox_integration'],
                    },
                    {
                        name: 'Registrera betalningar (Fortnox)',
                        icon: 'icon-database-export',
                        job: 'fortnox_register_payments',
                        permisson: ['red_fortnox_integration'],
                    },
                    {
                        name: 'Hämta betalningar (Fortnox)',
                        icon: 'icon-database-insert',
                        job: 'fortnox_fetch_payments',
                        permisson: ['red_fortnox_integration'],
                    },
                ],
            },
            {
                label: 'Löner',
                jobs: [
                    {
                        name: 'Registrera arbetade tider (Fortnox)',
                        icon: 'icon-file-upload',
                        job: 'fortnox_register_worktime',
                        permisson: ['red_fortnox_integration'],
                    },
                ],
            },
        ],
    }),
    watch: {
        timecare_period(newVal) {
            const datefilter = newVal.split('_');
            this.dispatch_data.date_from = datefilter[0];
            this.dispatch_data.date_to = datefilter[1];
        },
    },
    methods: {
        async dispatch(job) {
            if (job === 'fortnox_register_worktime' && this.dispatch_data.job !== job) {
                this.dispatch_data = {
                    job: 'fortnox_register_worktime',
                    user_ids: [],
                    date_from: null,
                    date_to: null,
                };
                const today = new Date();
                if (today.getDate() < 20) {
                    this.timecare_period = this.select_timecard_periods[this.select_timecard_periods.length - 2].id;
                } else {
                    this.timecare_period = this.select_timecard_periods[this.select_timecard_periods.length - 1].id;
                }
                this.$bvModal.show('modal-register-worktime');
            } else {
                this.busy_working = true;
                this.job_status_id = null;
                this.job_status = null;
                this.job_type = job;
                await apiClient.post('/vue/jobs/dispatch/' + job, this.dispatch_data)
                    .then((response) => {
                        this.job_status_id = response.data.job_status_id;
                        this.pollStatus();
                        this.interval = setInterval(() => {
                            this.pollStatus();
                        }, 5000);
                    })
                    .catch(() => {
                        this.clearTimer();
                    })
                    .finally(() => {
                        this.dispatch_data = {
                            job: '',
                        };
                    });
            }
        },
        pollStatus() {
            if (this.job_status_id > 0) {
                apiClient.get('/vue/jobs/status/' + this.job_status_id)
                    .then((response) => {
                        this.job_status = response.data;
                        if (response.data.status === 'finished') {
                            this.clearTimer();
                        } else if (response.data.status === 'retrying' && response.data.attempts >= 3) {
                            this.clearTimer();
                        } else if (response.data.status === 'failed') {
                            this.clearTimer();
                        }
                    })
                    .catch(() => {
                        this.clearTimer();
                    });
            } else {
                this.clearTimer();
            }
        },
        clearTimer() {
            this.busy_working = false;
            clearInterval(this.interval);
        },
    },
    beforeDestroy() {
        this.clearTimer();
    },
    computed: {
        status_log_errors() {
            let arr = [];
            if (this.job_status && this.job_status.output && this.job_status.output.log) {
                arr = this.job_status.output.log.filter((log) => log.type === 'error');
            }
            return arr;
        },
        status_log_warnings() {
            let arr = [];
            if (this.job_status && this.job_status.output && this.job_status.output.log) {
                arr = this.job_status.output.log.filter((log) => log.type === 'warning');
            }
            return arr;
        },
        status_log_infos() {
            let arr = [];
            if (this.job_status && this.job_status.output && this.job_status.output.log) {
                arr = this.job_status.output.log.filter((log) => log.type === 'info');
            }
            return arr;
        },
        job_status_message() {
            let text = '';
            if (this.job_status && this.job_status) {
                if (this.job_status.status === 'queued') {
                    text = 'Ligger i kö...';
                } else if (this.job_status.status === 'executing') {
                    text = 'Arbetar...';
                } else if (this.job_status.status === 'finished') {
                    text = 'KLAR!';
                } else if (this.job_status.status === 'failed') {
                    text = 'Något gick fel...';
                } else if (this.job_status.status === 'retrying') {
                    if (this.job_status.attempts >= 3) {
                        text = 'Något gick fel...';
                    } else {
                        text = 'Något gick fel... Försöker igen...';
                    }
                }
            } else {
                text = 'Väntar på status...';
            }
            return text;
        },
        filtered_job_groups() {
            // eslint-disable-next-line array-callback-return
            return this.jobs_groups.map((group) => {
                group.jobs = group.jobs.filter((job) => {
                    let hasAnyPermission = true;
                    if (job.permisson.length > 0) {
                        hasAnyPermission = false;
                        job.permisson.forEach((permisson) => {
                            hasAnyPermission = hasAnyPermission || hasPermission(permisson);
                        });
                    }
                    return hasAnyPermission;
                });
                return group;
            }).filter((group) => group.jobs.length > 0);
        },
        select_timecard_periods() {
            const months = ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'];
            const arr = [];
            const startDate = new Date();
            const endDate = new Date();
            startDate.setDate(16);
            startDate.setMonth(startDate.getMonth() - 12);
            endDate.setDate(15);
            endDate.setMonth(endDate.getMonth() - 11);
            let startStr = '';
            let endStr = '';
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i <= 12; i++) {
                startStr = startDate.getFullYear() + '-' + (startDate.getMonth() + 1).toString().padStart(2, '0') + '-' + startDate.getDate();
                endStr = endDate.getFullYear() + '-' + (endDate.getMonth() + 1).toString().padStart(2, '0') + '-' + endDate.getDate();
                arr.push({ id: startStr + '_' + endStr, text: months[(endDate.getMonth())] + ' (' + startStr + ' - ' + endStr + ')', no: endDate.getMonth() });
                startDate.setMonth(startDate.getMonth() + 1);
                endDate.setMonth(endDate.getMonth() + 1);
            }
            return arr;
        },
    },
};

</script>
